import React from 'react';

type BubbleMaskType = 'lowercased';

export interface BubbleMaskChildProps {
  onValue?: (value: string) => void;
}

export interface BubbleMaskPropsBase {
  onMask?: (value: string) => void;
  masks?: BubbleMaskType[];
}

export type BubbleMaskProps = {
  children: (props: BubbleMaskChildProps) => React.ReactNode;
} & BubbleMaskPropsBase;

export default function BubbleMask(props: BubbleMaskProps) {
  const { masks, onMask, children } = props;

  function onValue(val: string) {
    let finalVal = val;

    (masks || []).forEach(m => {
      finalVal = processMask(finalVal, m);
    });

    if (onMask) onMask(finalVal);
  }

  return <>{children({ onValue })}</>;
}

function processMask(val: string, mask: BubbleMaskType): string {
  switch (mask) {
    case 'lowercased':
      return val.toLowerCase();
  }
}
